.frame {
  position: relative;
  overflow: hidden;
  flex: none;
  /* As wide as allowed, but never taller than allowed: both limits keep the proportions. */
  width: min(var(--image-max-width, 100%), calc(var(--image-max-height, 100vh) * var(--image-ratio)));
  max-width: 100%;
  aspect-ratio: var(--image-ratio);
  border-radius: var(--image-radius, var(--radius-lg));
  box-shadow: var(--image-shadow, var(--shadow-md));
  background: var(--color-surface-sunken);
}

.pending {
  background: var(--color-skeleton);
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  /* The frame already has the image's shape; contain only guards against rounding. */
  object-fit: contain;
  opacity: 0;
  transition: opacity var(--duration-slow) var(--ease-standard);
}

.visible {
  opacity: 1;
}

.fallback {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  color: var(--color-text-subtle);
}
